import React, { useMemo, useState } from 'react'
import { useCourses } from '../../../hooks/v2/useCourses';
import Courses from '../../Courses';
import { Box, Card, CardActionArea, CardContent, CardMedia, IconButton, Stack, Typography } from '@mui/material';
import { CheckoutPageDashboard } from './CheckoutPageDashboard';
import styled from 'styled-components';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';


const CheckoutPageSelectCourse = () => {
    const { courses, coursesArray } = useCourses();
    const [selectedCourseId, setSelectedCourseId] = useState<string | undefined>(undefined);

    return (
        <>
            {selectedCourseId === undefined && (
                <Stack direction='row' spacing={1} justifyContent='center' alignItems='center' useFlexGap flexWrap="wrap">
                    {coursesArray.map((course) => (
                        <Card sx={{ maxWidth: 200 }} key={course.id}>
                            <CardActionArea onClick={() => setSelectedCourseId(course.id)}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image={course.image}
                                    style={{
                                        objectFit: 'contain'
                                    }}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="subtitle1" component="div">
                                        {course.title}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    ))}
                </Stack>
            )}
            {selectedCourseId !== undefined && (
                <Stack spacing={2}>
                    <Stack spacing={2} direction='row' alignItems='center'>
                        <IconButtonStyled size="medium" onClick={() => setSelectedCourseId(undefined)}>
                            <ArrowBackIcon fontSize="large" htmlColor='#32b0ea' />
                        </IconButtonStyled>
                        {courses[selectedCourseId] !== undefined && (
                            <Typography gutterBottom variant="h5" component="div">
                                {courses[selectedCourseId]?.title}
                            </Typography>
                        )}
                    </Stack>
                    <CheckoutPageDashboard courseId={selectedCourseId} />
                </Stack>
            )}
        </>
    );
}


export default CheckoutPageSelectCourse;


const IconButtonStyled = styled(IconButton)({
    '&.MuiIconButton-root': {
        borderRadius: 15,
        borderWidth: 1,
        borderColor: '#32b0ea',
        borderStyle: 'solid'
    }
})
